import type { PaginationProps } from 'antd';
import { RefObject, useEffect } from 'react';
import { FormRef } from '../common/form';
import type { PageOfAnyRecordsType } from '../common/utils';
import type { DraftableRow } from './useEditSession';

export const isUnvalidated = <Row extends DraftableRow>(row: Row) =>
  !('id' in row) || typeof row.id !== 'number' || row.id < 1;

export const useSyncFormToNewLoadedData = (
  pageData: PageOfAnyRecordsType | undefined,
  formRef: RefObject<FormRef<any> | null>,
) => {
  useEffect(() => {
    if (pageData) {
      formRef.current?.form.reset(
        { samples: pageData.content },
        { keepDefaultValues: true },
      );
    }
  }, [pageData, formRef]);
};

// Make sure the page number stays within totalPages.
// After deleting the last item on the last page, the user would be
// left stranded on an empty page out of bounds.
export const useClampPageToBounds = (
  pageData: PageOfAnyRecordsType | undefined,
  onPageChange: PaginationProps['onChange'],
) => {
  useEffect(() => {
    if (!pageData) {
      return;
    }
    const lastPage = Math.max(0, pageData.totalPages - 1);
    if (pageData.number > lastPage) {
      onPageChange?.(lastPage, pageData.size);
    }
  }, [pageData, onPageChange]);
};
